//import Vue from 'vue'
import Vue from 'vue/dist/vue.js'
import Vuex from 'vuex'
import firebase from 'firebase'
import { userRef, eventsRef } from '../../firebase'
import moment from 'moment-timezone'

import { createHelpers } from 'vuex-map-fields'

const { getInfoField, updateInfoField } = createHelpers({
  getterType: 'getInfoField',
  mutationType: 'updateInfoField',
});

//var moment = require('moment-timezone')

function convertDateToUTC(date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}

function convertDateToUTC2(date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()))
}

function numberToString(num) {
  var number = num
  if(num < 10) {
    number = '0' + num
  }
  return number
}

function getOffset(time, timeZoneId) {
  // get the current time so we know which offset to take (DST is such bullkitten)
  var time = moment.utc(time);
  // get the zone offsets for this time, in minutes
  var user = moment.tz.zone(moment.tz.guess()).utcOffset(time);
  var route = moment.tz.zone(timeZoneId).utcOffset(time);
  // calculate the difference in hours

  console.log("returned offset: " + (user - route))
  return (user - route)
}

//require('moment-timezone');

export default {
  state: {
    information: {
      name: '',
      description: '',
      start: {
        date: '',
        time: {
          HH: '',
          mm: ''
        }
      },
      end: {
        date: '',
        time: {
          HH: '',
          mm: ''
        }
      },
      tracking: true,
      notRace: true,
      initialized: false
    },
    privateId: {
      id: '',
      initialized: false
    }
  },
  getters: {
    getInfoField
  },
  mutations: {
    setInformation(state, value) {
      console.log("setting information")
      state.information = value
    },
    setPrivateId(state, value) {
      console.log("setting privateId to: ")
      console.log(value)
      state.privateId = value
    },
    unInitialize(state) {
      console.log("unInitializing Information")
      state.information.initialized = false
      state.privateId.initialized = false
    },
  },
  actions: {
    unInitializeInfo({commit}) {
      commit('unInitialize')
    },
    submitEventKey({ rootState }, key) {
      const id = rootState.race['.key']
      userRef.child(firebase.auth().currentUser.uid).child('races').child(id).child('privateId').set(key)
    },
    initInformation({commit, state, rootState}) {
      return new Promise((resolve, reject) => {
        console.log("InitInformation")

        let raceData = rootState.isMyRaces ? rootState.race.data : rootState.race

        console.log(raceData)

        //Convert timestamp to moment dates
        var momentStart = moment(raceData.event.start * 1000)
        var momentEnd = moment(raceData.event.end * 1000)

        //Converts moment dates to javascript date
        //Minutes are added to make the local time look like the race country's time
        //Javascript date doesn't include timezones, and will take the browser timezone
        var startDate = momentStart.add(getOffset(raceData.event.start * 1000, raceData.timezone.timeZoneId), 'm').toDate()
        var endDate = momentEnd.add(getOffset(raceData.event.end * 1000, raceData.timezone.timeZoneId), 'm').toDate()

        let information = {
          name: raceData.event.name,
          description: raceData.event.description,
          tracking: raceData.event.tracking,
          notRace: raceData.event.notRace,
          endMessage: raceData.event.endMessage || null,
          routeGroup: raceData.event.routeGroup || null,
          start: {
            date: startDate,
            time: {
              HH: numberToString(momentStart.hours()),
              mm: numberToString(momentStart.minutes())
            }
          },
          end: {
            date: endDate,
            time: {
              HH: numberToString(momentEnd.hours()),
              mm: numberToString(momentEnd.minutes())
            }
          },
          initialized: true
        }

        console.log(information)
        commit('setInformation', information)
        resolve()
      })

    },
    initPrivateId({commit, state, rootState}) {
      console.log(rootState.race)
      console.log("race privateId: ")
      console.log(rootState.race.privateId)

      let value = {
        privateId: {
          id: rootState.race.privateId,
          initialized: true
        }
      }

      commit('setPrivateId', value)
    },
    submitInformation({commit, state, rootState}, information) {
      const id = rootState.race['.key']
      return userRef.child(firebase.auth().currentUser.uid).child('races').child(id).child('event').set(information)
    }
  }
}
